export default __webpack_public_path__ + "static/media/jul5.f5b1c58c.jpg";